import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  Row,
  Table,
  Image,
  Form,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
  InputGroup
} from 'react-bootstrap'
import NavTitle from '../../../nav-title'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { getPositionAPI } from '../../../../services/position'
import {
  PAGE_SETTING,
  PIM_ORG_DEPARTMENT,
  PIM_ORG_FACTION,
  PIM_ORG_TEAM
} from '../../../../router/routes'
import {
  BsChevronLeft,
  BsChevronRight,
  BsPlusLg,
  BsSearch
} from 'react-icons/bs'

import { useDebounce } from '@react-hook/debounce'
import TextNavTitle from '../../../TextNavTitle'
import editImg from '../../../../images/Edit.svg'
import CardCustom from '../../../custom/card-custom'

import AddAndUpdatePosition from './add-and-update'
import UseNotebookType from '../../../../hooks/use-notebook-type'
import TableSkeletonBody from '../../../custom/TableSkeletonBody'

export default function Index() {
  let [searchParams] = useSearchParams()
  const optionNotebookType = UseNotebookType()
  const orgId = searchParams.get('orgId')
  const factionId = searchParams.get('factionId')
  const divisionId = searchParams.get('divisionId')
  const departmentId = searchParams.get('departmentId')
  const teamId = searchParams.get('teamId')
  const [dataTable, setdataTable] = useState([])
  const navigate = useNavigate()
  const param = { orgId, divisionId, departmentId, teamId }
  const divisionName = searchParams.get('nameGroup')
  const factionName = searchParams.get('nameDepartment')
  const departmentName = searchParams.get('nameDivision')
  const teamName = searchParams.get('nameTeam')

  const [input, setInput] = useDebounce('', 1000)
  const [isLoading, setIsLoading] = useState(true)

  const [updateShow, setUpdateShow] = useState({ isShow: false, data: null })
  useEffect(() => {
    getPosition()
  }, [input])

  const getPosition = async () => {
    setIsLoading(true)
    const result = await getPositionAPI({
      ...param,
      searchs: input
    })
    setIsLoading(false)
    if (!result) return
    if (result.status) {
      setdataTable(result.result)
    } else {
      setdataTable([])
    }
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>
          <Link
            className="link"
            style={{ color: '#7A7A7A' }}
            onClick={() => {
              navigate(-1)
            }}
          >
            <BsChevronLeft /> Positions
          </Link>
        </TextNavTitle>
      </NavTitle>
      <p className="fw-normal  text-secondary ">
        <Link
          className="link text-secondary "
          to={`${PAGE_SETTING}?orgId=${orgId}`}
        ></Link>
        <Link
          className="link text-secondary"
          to={`${PAGE_SETTING}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}`}
        >
          {`Group: ${divisionName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_FACTION}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}`}
        >
          <BsChevronRight /> {`Division: ${factionName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_DEPARTMENT}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}&departmentId=${departmentId}&nameDivision=${departmentName}`}
        >
          <BsChevronRight /> {`Department: ${departmentName}`}
        </Link>
        <Link
          className="link text-secondary"
          to={`${PIM_ORG_TEAM}?orgId=${orgId}&divisionId=${divisionId}&nameGroup=${divisionName}&factionId=${factionId}&nameDepartment=${factionName}&departmentId=${departmentId}&nameDivision=${departmentName}`}
        >
          <BsChevronRight />
          {`Team: ${teamName}`}
        </Link>
        <span className="link" style={{ color: '#C7C7C7' }}>
          <BsChevronRight /> Position
        </span>
      </p>

      <Col xl={12}>
        <CardCustom className="h-full" border="0">
          <div className="p-3 ">
            <Col
              xl={12}
              className="my-auto d-flex gap-3 justify-content-between"
              style={{ flexWrap: 'wrap' }}
            >
              <label
                className=" my-auto fw-bold"
                style={{
                  fontSize: '14px'
                }}
              >
                Total: {dataTable.length?.toLocaleString()}
              </label>
              <div className="d-flex justify-content-end gap-2 ">
                <span style={{ minWidth: '300px' }}>
                  <InputGroup>
                    <InputGroup.Text
                      id="basic-addon1"
                      className="bg-white border-end-0  text-muted"
                    >
                      <BsSearch className="opacity-50" />
                    </InputGroup.Text>
                    <Form.Control
                      className="border-start-0 ps-0 placeholder-text"
                      placeholder="Position EN/ Position TH"
                      onChange={(e) => setInput(e.target.value)}
                    />{' '}
                  </InputGroup>
                </span>
                <span>
                  <Button
                    className="btn btn-primary "
                    onClick={() => {
                      // setShowCreate(true)
                      setUpdateShow({ isShow: true, data: null })
                    }}
                    size="sm"
                    style={{
                      minWidth: '150px'
                    }}
                  >
                    <BsPlusLg /> Add Position
                  </Button>
                </span>
              </div>
            </Col>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th className=" fw-normal">#</th>
                <th className=" fw-normal">Level</th>
                <th className=" fw-normal">Position EN</th>
                <th className=" fw-normal">Position TH</th>
                <th className=" fw-normal text-center">Computer Type</th>

                <th className=" fw-normal">Head Count</th>

                <th className=" fw-normal text-center"> Count of Employee</th>
                <th className=" fw-normal text-center"> Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableSkeletonBody colSpan={8} rowSpan={10} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr key={i} className="fw-light font-small-2">
                    <td>{i + 1}</td>
                    <td>{d.level_id}</td>
                    <td className="">{d.position_en}</td>
                    <td className="">{d.position_th}</td>
                    <td className="text-center">{d.notebook_type_name}</td>

                    <td>{d?.headcount || '0'}</td>

                    <td className="text-center">{d.count_emp}</td>
                    <td className="text-center ">
                      <span className="d-flex justify-content-center">
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Edit</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => {
                                // setDetailTable(d)
                                // handleEditButtonClick()
                                setUpdateShow({ isShow: true, data: d })
                              }}
                            >
                              <Image
                                src={editImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="fw-light ">
                  <td colSpan={8} className="text-center">
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardCustom>
      </Col>

      {updateShow.isShow && (
        <AddAndUpdatePosition
          param={param}
          optionNotebookType={optionNotebookType}
          fnGetList={() => getPosition()}
          show={updateShow.isShow}
          isEdit={updateShow.isEdit}
          data={updateShow.data}
          onCancel={() => setUpdateShow({ isShow: false, isEdit: true })}
        />
      )}
    </Row>
  )
}
